import type { ICard } from "../../api/cardsSlice";
import type { ISpread } from "../../api/spreadsSlice";
import { resolveCardSections } from "./resolveCardSections";
import { DEFAULT_READING_CONTEXT } from "./types";
import type {
  ReadingContext,
  PositionReading,
  SpreadReadingProfile,
} from "./types";

export interface BuildSpreadReadingArgs {
  spread: ISpread;
  cards: ICard[];
  profile: SpreadReadingProfile;
  context?: ReadingContext;
}

export const buildSpreadReading = ({
  spread,
  cards,
  profile,
  context = DEFAULT_READING_CONTEXT,
}: BuildSpreadReadingArgs): PositionReading[] => {
  if (profile.spreadId !== spread.id) {
    throw new Error(
      `Reading profile "${profile.spreadId}" не соответствует раскладу "${spread.id}"`
    );
  }

  if (cards.length !== spread.positions.length) {
    throw new Error(
      `Для расклада "${spread.id}" ожидалось ` +
        `${spread.positions.length} карт, получено ${cards.length}`
    );
  }

  return spread.positions.map((position, index) => {
    const card = cards[index];

    const definitions =
      profile.positionOverrides?.[position.id]?.sections ??
      profile.sections;

    return {
      positionId: position.id,
      positionTitle: position.title,
      positionMeaning: position.meaning,
      cardId: card.id,
      cardName: card.name,
      cardNameEn: card.nameEn,
      sections: resolveCardSections(
        card,
        definitions,
        context
      ),
    };
  });
};
